module.exports = __webpack_public_path__ + "assets/img/mr8.728ec052.png";